import axios from "axios"

export default {
    namespaced:true,
    state: {
        premiumRides: [],
        requirePremiumRides: []
      },
    
      actions: {
    
        getPremiumRides({commit}) {
          axios.get('read-rides',{params:{ride_type:'luxury'},
          headers:{
            'Authorization': 'Bearer '+JSON.parse(localStorage.getItem('user')).token
          }
        }).then((response) => {
            commit('setPremiumRides', response.data.rides)
            return response
          }).catch((error) => {
            console.log(error)
          })
        },

        getPremiumRidesForDetail({commit}) {
          axios.get('read-rides',{params:{ride_type:'luxury'},
          headers:{
            'Authorization': 'Bearer '+JSON.parse(localStorage.getItem('user')).token
          }
        }).then((response) => {
            commit('setPremiumRidesForDetail', response.data.rides)
            return response
          }).catch((error) => {
            console.log(error)
          })
        },
    
        removeDriver({commit},id){
          axios.post('dismiss-driver/'+id,{
            headers:{
              'Authorization': 'Bearer '+JSON.parse(localStorage.getItem('user')).token
            }
          }).then(()=>{
            commit('removeDriver',id)
          }).catch((err)=>{
            console.log(err)
          })
    
        },
    
        assignDriver({commit},payload){
          return new Promise((resolve,reject)=> {
            axios.post('assign-driver/'+payload.ride._id, { new_driver_number: payload.newNumber,vehicle_id: payload.vehicle_id},{
              headers:{
                'Authorization': 'Bearer '+JSON.parse(localStorage.getItem('user')).token
              }
            }).then((response) => {
              if (response) {
                commit('assignDriver', {newNumber: payload.newNumber, ride_id: payload.ride._id})
                resolve(response)
              }
            }).catch((error) => {
              reject(error)
            })
          })
        },
        setRequiredPremiumRides({commit}, value){
          commit('setRequiredPremiumRidesData', value)
        }
    
    
      },
    
      mutations : {
    
        setPremiumRides(state, value) {
          state.premiumRides = value
          state.requirePremiumRides = value
        },
        setPremiumRidesForDetail(state, value) {
          state.premiumRides = value
        },

        setRequiredPremiumRidesData(state, value){
          if (value === 'reset'){
            state.requirePremiumRides = state.premiumRides
          }
          else{
            state.requirePremiumRides = state.premiumRides.filter(data => data.status === value)
            
          }
        },

        removeDriver(state,value){
          try {
            let index = state.premiumRides.findIndex(ride => ride._id === value)
            state.premiumRides[index].driver_id = null
          } catch (error){
            console.log(error)
          }
        },
    
        assignDriver(state,payload){
          let index= state.premiumRides.findIndex(ride => ride._id === payload.ride_id)
          state.premiumRides[index].driver_number=payload.newNumber
        }
      },
    
      getters : {
    
        premiumRidesGetter(state) {
          return state.requirePremiumRides
        },

        premiumRideGetter:(state) => (id) =>{
          return state.premiumRides.find(ride => ride._id === id)
        }
    
      }
}